module.exports = __webpack_public_path__ + "img/txt_info3.f26fa787.png";